// material-ui
import { Container, Grid, Typography } from '@mui/material';

// project import
import MainCard from '../../Components/MainCard';
import Animation from './Animation';

// ==============================|| LANDING - FEATURE PAGE ||============================== //

const FeatureBlock = () => (
  <Container>
    <Grid container alignItems="center" justifyContent="center" spacing={2} sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
      <Grid item xs={12}>
        <Grid container spacing={1} justifyContent="center" sx={{ mb: 4, textAlign: 'center' }}>
          <Grid item sm={10} md={6}>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12}>
                <Typography variant="subtitle1" color="primary">
                  (ee-key-guy)
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h2" sx={{ mb: 2 }}>
                  What is Ikigai?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  The value of being alive.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        >
          <MainCard contentSX={{ p: 3, background: '#f8f9fa'}}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {/*<img src={imgfeature1} alt="feature" />*/}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                  Accomplishment
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="grey">
                  Each day see your progress.
                </Typography>
              </Grid>
            </Grid>
          </MainCard>
        </Animation>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        >
          <MainCard contentSX={{ p: 3, background: '#f8f9fa'}}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {/*<img src={imgfeature2} alt="feature" />*/}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                  Fulfillment
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="grey">
                  See how your actions impacts society.
                </Typography>
              </Grid>
            </Grid>
          </MainCard>
        </Animation>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        >
          <MainCard contentSX={{ p: 3, background: '#f8f9fa' }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {/*<img src={imgfeature3} alt="feature" />*/}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                  Passion
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="grey">
                  You do it because you enjoy it.
                </Typography>
              </Grid>
            </Grid>
          </MainCard>
        </Animation>
      </Grid>
    </Grid>
  </Container>
);

export default FeatureBlock;